// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 60px; /* collapsed width */
  transition: width 0.3s ease;
  overflow: hidden;
}

.sidebar:hover {
  width: 200px; /* expanded width */
}

.sidebar-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  white-space: nowrap;
}

.icon {
  font-size: 18px;
  min-width: 20px;
  text-align: center;
  margin-right: 10px;
}

.text {
  opacity: 0;
  transition: opacity 0.3s ease;
}

.sidebar:hover .text {
  opacity: 1; /* show text when expanded */
}

.nav-link.active {
  background-color: #f0f0f0;
  border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,WAAW,EAAE,oBAAoB;EACjC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,YAAY,EAAE,mBAAmB;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU,EAAE,4BAA4B;AAC1C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".sidebar {\n  width: 60px; /* collapsed width */\n  transition: width 0.3s ease;\n  overflow: hidden;\n}\n\n.sidebar:hover {\n  width: 200px; /* expanded width */\n}\n\n.sidebar-item {\n  display: flex;\n  align-items: center;\n  padding: 10px 12px;\n  white-space: nowrap;\n}\n\n.icon {\n  font-size: 18px;\n  min-width: 20px;\n  text-align: center;\n  margin-right: 10px;\n}\n\n.text {\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.sidebar:hover .text {\n  opacity: 1; /* show text when expanded */\n}\n\n.nav-link.active {\n  background-color: #f0f0f0;\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
